import { Component, inject } from '@angular/core';
import { HelpService } from '@shared/services';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'help-dialog',
  templateUrl: './help-dialog.component.html',
  standalone: false,
})
export class HelpDialogComponent {
  helpService = inject(HelpService);
}
